import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class CustomLink extends Component {
    isExternal (url) {
        return /^https?:\/\//.test(url)
    }

    handleClick (event) {
        window.scrollTo(0, 0)
    	if (this.props.onClick) {
    		this.props.onClick(event)
        }
    }

    render () {
        return this.isExternal(this.props.to)
            ? <a
                    href={this.props.to}
                    target='_blank'
                    {...this.props}
              />
            : <Link {...this.props} onClick={this.handleClick.bind(this)} />
    }
}

export default CustomLink



// WEBPACK FOOTER //
// ./resources/js/components/CustomLink.js